module.exports = __webpack_public_path__ + "static/collide-47e52106639c01f39cb262c128761146.jpg";